// 引入插件模块
import VueRouter from 'vue-router';
import Vue from 'vue';

// 引入主页面
import Service from '../pages/Service';

// 引入次级页面
import Doctors from '../pages/Doctors';
import Questions from '../pages/Questions';
import Detail from '../pages/Detail';
import Rates from '../pages/Rates';
import {pageScroll} from '../assets/utils';

// 引入模块按 router-view 嵌套路由使用
Vue.use(VueRouter);

// 配置
const routes = [
  {                              // 快问首页
    path: '/',
    name: 'question',
    component: Questions,
    meta: {
      requiresAuth: false         // 是否需要登录
    }
  },
  {                              // 服务历史页
    path: '/lists/',
    name: 'index',
    component: Service,
    meta: {
      requiresAuth: true         // 是否需要登录
    }
  },
  {
    path: '/doctor/:id',
    name: 'doctor',
    component: Doctors,
    meta: {
      requiresAuth: false         // 是否需要登录
    }
  },
  {
    path: '/question/',
    name: 'question',
    component: Questions,
    meta: {
      requiresAuth: false       // 是否需要登录
    }
  },
  {                             // 问题详情页
    path: '/detail/:id',
    name: 'detail',
    component: Detail,
    meta: {
      requiresAuth: true        // 是否需要登录
    }
  },
  {
    path: '/rate/:id/:doctorId',
    name: 'rate',
    component: Rates,
    meta: {
      requiresAuth: false        // 是否需要登录
    }
  }
];

// 传入配置
const router = new VueRouter({
  base: '/inquiry/',
  mode: 'history',
  // base: __dirname,
  routes
});

// 处理ios拖拽整个页面问题
router.afterEach(() => {
  if (window.MT && window.MT.controlWebViewScroll) {
    window.MT.controlWebViewScroll(true);
    console.log('ios app controlWebViewScroll set yes');
  } else {
    console.log('unlock');
    pageScroll.unlock();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/routes/index.js